import React from 'react';
import tmrAccounts from '@redux/modules/tmrAccounts';
import styles from './billingAccountDetails.module.scss';
import { UpgradeForm } from '@components/upgradeForm/UpgradeForm';

export const BillingAccountDetails = () => {
  const { data, isFetching, error, refetch } = tmrAccounts
    .list()
    .useTmrAccountdetailQuery({ extendedPath: '/current' });

  const accountStatus = data?.data;
  const account = accountStatus?.account;
  const usage = accountStatus?.client_usage;
  const capabilities = accountStatus?.capabilities;
  const planLabel = account?.account_level
    ? account.account_level.charAt(0).toUpperCase() + account.account_level.slice(1)
    : 'Unknown';
  const hasUnlimitedClients = usage?.remaining === null;
  const clientLimit = hasUnlimitedClients ? 'Unlimited' : usage?.limit;

  const rawError =
    error?.data?.errors ||
    error?.data?.message ||
    error?.error ||
    null;
  const errorMessage =
    typeof rawError === 'string'
      ? rawError
      : rawError
        ? JSON.stringify(rawError)
        : 'Account details could not be loaded.';
  // Profile completion from API (available even when access is denied)
  const profileCompletion = accountStatus?.profile_completion ||
    error?.data?.data?.profile_completion;
  const profilePercent = profileCompletion?.percent ?? 0;
  const profileDone = profileCompletion?.is_complete ?? false;

  return (
    <div className={styles.wrapper}>
      <h3>Billing and account details</h3>
      {isFetching && <div className={styles.notice}>Loading account details...</div>}
      {error && (
        <div className={styles.error}>
          <p>{errorMessage}</p>
          <button type="button" onClick={refetch} style={{ marginTop: '8px' }}>Retry</button>
        </div>
      )}
      {accountStatus && (
        <>
          <div className={styles.summaryGrid}>
            <div className={styles.summaryItem}>
              <span>Plan</span>
              <strong>{planLabel}</strong>
            </div>
            <div className={styles.summaryItem}>
              <span>Status</span>
              <strong>{account?.status || 'Unknown'}</strong>
            </div>
            <div className={styles.summaryItem}>
              <span>Clients in active workspace</span>
              <strong>{usage?.count || 0} / {clientLimit}</strong>
            </div>
            <div className={styles.summaryItem}>
              <span>Profile</span>
              <strong style={{ color: profileDone ? '#16a34a' : '#d97706' }}>
                {profilePercent}%
              </strong>
            </div>
          </div>

          <div className={styles.section}>
            <h4>Capabilities</h4>
            <div className={styles.capabilityRow}>
              <span>Create clients</span>
              <strong>{usage?.can_create_client ? 'Available' : 'Limit reached'}</strong>
            </div>
            <div className={styles.capabilityRow}>
              <span>Jobs embed</span>
              <strong>{capabilities?.can_use_jobs_embed ? 'Available' : 'Business or Enterprise'}</strong>
            </div>
          </div>

          {!usage?.can_create_client && (
            <div className={styles.notice}>
              Your current account has reached its client allowance.
            </div>
          )}
        </>
      )}

      {accountStatus && account?.account_level === 'free' && (
        <UpgradeForm
          account={account}
          onUpgraded={() => refetch()}
        />
      )}
    </div>
  );
};
